<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="layout">
    <div class="main">
      <header class="topbar">
        <div class="breadcrumb" routerLink="/student-dashboard/resume">
          <b> <span>All Resumes</span></b>
          <ng-container *ngIf="studentResumeDetails as resume">
            / {{ resume.resume_name || "Untitled Resume" }}
          </ng-container>
        </div>

        <div class="actions">
          <button
            *ngIf="returnUrl"
            class="primary"
            (click)="useResumeToApply()"
            [disabled]="isApplyingToJob"
            style="background: #10b981; border-color: #10b981;"
          >
            <ng-container *ngIf="!isApplyingToJob">
              <i class="bi bi-check-circle"></i>
              {{ returnUrl && returnUrl.includes('/profile') ? 'Use this Resume' : 'Use this Resume to Apply' }}
            </ng-container>
            <ng-container *ngIf="isApplyingToJob">
              <i class="bi bi-arrow-repeat spin"></i> Applying...
            </ng-container>
          </button>

          <ng-container *hasPermission="PermissionForStudents.RESUME_UPDATE">
            <button
              *ngIf="studentResumeDetails as resume"
              (click)="goToEditPage(resume.resume_id)"
            >
              <i class="bi bi-pencil"></i>
              Edit Content
            </button>
          </ng-container>

          <ng-container *hasPermission="PermissionForStudents.RESUME_ANALYZE">
            <button (click)="showScoreAndAnalyze()">
              <i class="bi bi-bar-chart-line"></i>
              Check Resume Score
            </button>
          </ng-container>

          <ng-container *hasPermission="PermissionForStudents.RESUME_UPDATE">
            <button (click)="openSaveResumeDialogBox()">
              <i class="bi bi-save"></i>
              Save
            </button>
          </ng-container>

          <button
            class="primary"
            (click)="downloadPDF()"
            [disabled]="isDownloading"
          >
            <ng-container *ngIf="!isDownloading">
              <i class="bi bi-download"></i>
              Download PDF
            </ng-container>
            <ng-container *ngIf="isDownloading">
              <i class="bi bi-arrow-repeat spin"></i> Downloading...
            </ng-container>
          </button>
        </div>
      </header>

      <app-resumer-check-score
        *ngIf="showScore"
        [resumeId]="resumeId"
        (close)="handleCloseScore()"
      ></app-resumer-check-score>

      <div class="content">
        <div class="left-panel">
          <div class="card colors-card">
            <h4>Colors</h4>
            <div class="colors">
              <button
                *ngFor="let c of colors"
                [style.background-color]="c"
                [class.active]="selectedColor === c"
                (click)="selectColor(c)"
              ></button>
            </div>
          </div>

          <div class="card fonts-card">
            <h4>Font Family</h4>
            <div class="fonts">
              <button
                *ngFor="let f of fonts"
                [class.active]="selectedFont === f"
                (click)="changeFont(f)"
              >
                {{ f }}
              </button>
            </div>
          </div>

          <div class="card templates-card">
            <h4>Templates</h4>
            <div class="template-list">
              <div
                class="template-card"
                *ngFor="let t of templates; let i = index"
                [class.selected]="selectedTemplate === i"
                (click)="selectTemplate(i)"
              >
                <div
                  class="template-preview"
                  [ngClass]="t.type"
                  [ngStyle]="{ '--themeColor': selectedColor }"
                  [ngSwitch]="t.name"
                >

                  <ng-container *ngSwitchCase="'Classic'">
                    <div class="prev-header-row">
                      <div
                        class="prev-avatar"
                        *ngIf="studentResumeDetails?.config?.includePhoto"
                      ></div>
                      <div class="prev-header-text">
                        <div class="prev-name-line"></div>
                        <div class="prev-role-line"></div>
                      </div>
                    </div>
                    <div class="prev-divider"></div>
                    <div class="prev-section-title"></div>
                    <div class="prev-line"></div>
                    <div class="prev-line short"></div>
                    <div class="prev-section-title"></div>
                    <div class="prev-line"></div>
                    <div class="prev-line short"></div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Modern'">
                    <div class="prev-header-row">
                      <div
                        class="prev-avatar"
                        *ngIf="studentResumeDetails?.config?.includePhoto"
                      ></div>
                      <div class="prev-header-text">
                        <div class="prev-name-line wide"></div>
                        <div class="prev-role-line"></div>
                      </div>
                    </div>
                    <div class="prev-divider thick"></div>
                    <div class="prev-section-title"></div>
                    <div class="prev-line"></div>
                    <div class="prev-line short"></div>
                    <div class="prev-section-title"></div>
                    <div class="prev-line"></div>
                    <div class="prev-line short"></div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Minimal'">
                    <div class="prev-header-row">
                      <div
                        class="prev-avatar"
                        *ngIf="studentResumeDetails?.config?.includePhoto"
                      ></div>
                      <div class="prev-header-text">
                        <div class="prev-name-line"></div>
                        <div class="prev-role-line"></div>
                      </div>
                    </div>
                    <div class="prev-divider thin"></div>
                    <div class="prev-section-title"></div>
                    <div class="prev-line"></div>
                    <div class="prev-line short"></div>
                    <div class="prev-section-title"></div>
                    <div class="prev-line"></div>
                    <div class="prev-line short"></div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Professional'">
                    <div class="prev-header-block">
                      <div
                        class="prev-avatar white-avatar"
                        *ngIf="studentResumeDetails?.config?.includePhoto"
                      ></div>
                      <div class="prev-header-text">
                        <div class="prev-name-line white"></div>
                        <div class="prev-role-line white-dim"></div>
                      </div>
                    </div>
                    <div class="prev-section-title"></div>
                    <div class="prev-line"></div>
                    <div class="prev-line short"></div>
                    <div class="prev-section-title"></div>
                    <div class="prev-line"></div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Sidebar'">
                    <div class="prev-sidebar-left">
                      <div
                        class="prev-avatar white-avatar sm"
                        *ngIf="studentResumeDetails?.config?.includePhoto"
                      ></div>
                      <div class="prev-section-title white"></div>
                      <div class="prev-line white-dim"></div>
                      <div class="prev-line white-dim short"></div>
                      <div class="prev-section-title white"></div>
                      <div class="prev-line white-dim"></div>
                    </div>
                    <div class="prev-sidebar-right">
                      <div class="prev-name-line"></div>
                      <div class="prev-role-line"></div>
                      <div class="prev-line"></div>
                      <div class="prev-line short"></div>
                      <div class="prev-line"></div>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Executive'">
                    <div class="prev-exec-left">
                      <div class="prev-header-row">
                        <div
                          class="prev-avatar sm"
                          *ngIf="studentResumeDetails?.config?.includePhoto"
                        ></div>
                        <div class="prev-header-text">
                          <div class="prev-name-line"></div>
                          <div class="prev-role-line"></div>
                        </div>
                      </div>
                      <div class="prev-section-title"></div>
                      <div class="prev-line"></div>
                      <div class="prev-line short"></div>
                      <div class="prev-section-title"></div>
                      <div class="prev-line"></div>
                      <div class="prev-line short"></div>
                    </div>
                    <div class="prev-exec-divider"></div>
                    <div class="prev-exec-right">
                      <div class="prev-section-title"></div>
                      <div class="prev-line short"></div>
                      <div class="prev-line shorter"></div>
                      <div class="prev-section-title"></div>
                      <div class="prev-line short"></div>
                      <div class="prev-line shorter"></div>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Creative'">
                    <div class="prev-creative-left">
                      <div
                        class="prev-avatar white-avatar sm"
                        *ngIf="studentResumeDetails?.config?.includePhoto"
                      ></div>
                      <div class="prev-line white-dim"></div>
                      <div class="prev-line white-dim short"></div>
                      <div class="prev-line white-dim"></div>
                      <div class="prev-line white-dim short"></div>
                    </div>
                    <div class="prev-creative-right">
                      <div class="prev-name-line"></div>
                      <div class="prev-line"></div>
                      <div class="prev-line short"></div>
                      <div class="prev-section-title"></div>
                      <div class="prev-line"></div>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'Compact'">
                    <div class="prev-compact-header">
                      <div
                        class="prev-avatar sm"
                        *ngIf="studentResumeDetails?.config?.includePhoto"></div>
                    </div>
                    <div class="prev-compact-cols">
                      <div class="prev-compact-left">
                        <div class="prev-section-title"></div>
                        <div class="prev-line short"></div>
                        <div class="prev-line shorter"></div>
                        <div class="prev-section-title"></div>
                        <div class="prev-line short"></div>
                        <div class="prev-line shorter"></div>
                        <div class="prev-section-title"></div>
                        <div class="prev-line short"></div>
                      </div>
                      <div class="prev-compact-divider"></div>
                      <div class="prev-compact-right">
                        <div class="prev-line"></div>
                        <div class="prev-line short"></div>
                        <div class="prev-line"></div>
                        <div class="prev-section-title"></div>
                        <div class="prev-line"></div>
                        <div class="prev-line short"></div>
                        <div class="prev-line"></div>
                        <div class="prev-section-title"></div>
                        <div class="prev-line short"></div>
                        <div class="prev-line"></div>
                      </div>
                    </div>
                  </ng-container>

                </div>
                <div class="template-info">
                  <p>{{ t.name }}</p>
                  <span>{{ t.type }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preview">
          <ng-container
            *ngIf="studentResumeDetails"
            [ngSwitch]="selectedTemplate"
          >
            <app-classic
              *ngSwitchCase="0"
              [data]="studentResumeDetails"
              [color]="selectedColor"
              [font]="selectedFont"
            >
            </app-classic>

            <app-modern
              *ngSwitchCase="1"
              [data]="studentResumeDetails"
              [color]="selectedColor"
              [font]="selectedFont"
            >
            </app-modern>

            <app-minimal-template
              *ngSwitchCase="2"
              [data]="studentResumeDetails"
              [color]="selectedColor"
              [font]="selectedFont"
            >
            </app-minimal-template>

            <app-professional-template
              *ngSwitchCase="3"
              [data]="studentResumeDetails"
              [color]="selectedColor"
              [font]="selectedFont"
            >
            </app-professional-template>

            <app-sidebar
              *ngSwitchCase="4"
              [data]="studentResumeDetails"
              [color]="selectedColor"
              [font]="selectedFont"
            >
            </app-sidebar>

            <app-executive-template
              *ngSwitchCase="5"
              [data]="studentResumeDetails"
              [color]="selectedColor"
              [font]="selectedFont"
            >
            </app-executive-template>

            <app-creative-template
              *ngSwitchCase="6"
              [data]="studentResumeDetails"
              [color]="selectedColor"
              [font]="selectedFont"
            >
            </app-creative-template>

            <app-compact-template
              *ngSwitchCase="7"
              [data]="studentResumeDetails"
              [color]="selectedColor"
              [font]="selectedFont"
            >
            </app-compact-template>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!studentResumeDetails" class="empty-state">
    <p>No resume found.</p>
  </div>
</ng-template>
